import 'mq-respond';
import '@int_acf_core/cartridge/static/default/lib/js/lazysizes.min';

var header = require('./header');
var minicart = require('./minicart');
var searchsuggest = require('./searchsuggest');

var eventsInitialized = false;

$('.close-icon').tooltip({
    placement: "bottom",
    trigger: "focus",
    position: {
        my: "center top",
        at: "left bottom-10",
        collision: "none"
     }
    });

// Footer links accordion
(function() {
    window.mqR = window.mqR || new mqRes([
        {
            label: 'phone',
            from: 0,
            to: 767
        },
        {
            label: 'tablet',
            from: 768,
            to: 1023
        },
        {
            label: 'desktop',
            from: 1024,
            to: 1679
        },
        {
            label: 'desktopLarge',
            from: 1680
        }
    ]);

    window.mqR.add(function (status) {
        if (status.phone || status.tablet) {
            document.addEventListener('click', footerToggle);
        }

        if (status.desktop || status.desktopLarge) {
            document.removeEventListener('click', footerToggle);
        }
    });

    /**
     * @private
     * @function
     * @description function used for footer on cart
     */
    function footerToggle(event) {
        // Bail if our clicked element doesn't have the class
        if (!event.target.classList.contains('cart-accordion-toggle')) {
            return;
        }

        if (event.target.classList.contains('active-toggle')) {
            event.target.classList.remove('active-toggle');
        } else {
            var accordionToggle = document.querySelectorAll('.cart-accordion-toggle.active-toggle');

            for (var i = 0; i < accordionToggle.length; i++) {
                accordionToggle[i].classList.remove('active-toggle');
            }

            event.target.classList.add('active-toggle');
        }

        // Get the target content
        var content = document.querySelector(event.target.hash);
        if (!content) return;

        // Prevent default link behavior
        event.preventDefault();

        // If the content is already expanded, collapse it and quit
        if (content.classList.contains('active')) {
            content.classList.remove('active');
            return;
        }

        // Get all open accordion content, loop through it, and close it
        var accordions = document.querySelectorAll('.cart-accordion-content.active');

        for (var j = 0; j < accordions.length; j++) {
            accordions[j].classList.remove('active');
        }

        // Toggle our content
        content.classList.toggle('active');
    }

    header.init();
    minicart.init();

    /**
     * initialize search suggestions, pending the value of the site preference(enhancedSearchSuggestions)
     * this will either init the legacy(false) or the beta versions(true) of the the search suggest feature.
     * */
    var searchContainer = document.querySelector('.header .header__actions .header__search');

    if (document.getElementById('q') != null) {
        searchsuggest.init(searchContainer, document.getElementById('q').placeholder);
    }

    var searchField = document.getElementById('q');
    var searchSuggestionEnding = document.querySelector('.search-suggestion-ending__text');
    var searchOverlay = document.querySelector('.search-overlay');

    var tsY = 0;

    var touchStart = function(e) {
        tsY = e.originalEvent.touches[0].clientY;
    };

    var touchMove = function(e) {
        var tmY = e.originalEvent.touches[0].clientY;
        var isUpOverScroll = self.scrollTop === 0 && tsY < tmY;
        // 1px is lost, probably due to borders/box-sizing etc
        var isDownOverScroll = (self.scrollTop >= self.scrollHeight - self.offsetHeight - 1) && tsY > tmY;

        if (isUpOverScroll || isDownOverScroll) {
            e.preventDefault();
        }
    };

    function closeSearchOverlay() {
        searchContainer.classList.remove('active');
        document.querySelector('.search-suggestions-container').classList.remove('active');
        searchOverlay.classList.add('ms-hide');
        searchField.value = '';
        searchSuggestionEnding.innerText = '';
    }

    window.mqR.add(function (status) {
        if (eventsInitialized) {
            return;
        }

        window.addEventListener('click', function(e) {
            if (searchContainer.classList.contains('active') && !searchContainer.contains(e.target)) {
                closeSearchOverlay();
            }
        });

        if (status.phone || status.tablet) {
            if (searchContainer != null) {
                searchContainer.querySelector('.search-block').addEventListener('click', function() {
                    var resultsContainer = document.querySelector('.search-suggestions-container');
                    var searchQuery = document.getElementById('q').value;
                    if (searchContainer.classList.contains('active')) {
                        document.querySelector('html').classList.remove('ms-overflow-hidden');
                        closeSearchOverlay();
                        if (resultsContainer) {
                            resultsContainer.classList.remove('active');
                        }
                    } else {
                        document.querySelector('html').classList.add('ms-overflow-hidden');
                        searchContainer.classList.add('active');
                        document.getElementById('q').focus();
                        if (resultsContainer && searchQuery.length) {
                            resultsContainer.classList.add('active');
                        }
                    }
                });
            }
        }

        if (status.desktop || status.desktopLarge) {
            if (searchContainer != null) {
                searchContainer.querySelector('.search-block').addEventListener('click', function() {
                    setTimeout(() => {
                        searchContainer.classList.add('active');
                        document.getElementById('q').focus();
                    }, 0);
                });

                searchContainer.querySelector('.close-icon').addEventListener('click', function() {
                    var htmlBody = document.querySelectorAll('html, body');
                    var resultsContainer = document.querySelector('.search-suggestions-container');

                    closeSearchOverlay();

                    htmlBody[0].classList.remove('search-disable-scroll');
                    htmlBody[1].classList.remove('search-disable-scroll');

                    if (htmlBody[1].querySelector('.searchOverlayOpened') != null) {
                        htmlBody[1].querySelector('.searchOverlayOpened').removeEventListener('touchstart.searchOverlayOpened', touchStart);
                        htmlBody[1].querySelector('.searchOverlayOpened').removeEventListener('touchmove.searchOverlayOpened', touchMove);
                    }

                    if (resultsContainer) {
                        resultsContainer.classList.remove('active');
                        resultsContainer.innerHTML = '';
                    }
                });
            }
        }

        eventsInitialized = true;
    });

    var appContainer = document.querySelector('.cart');

    if (appContainer) {
        // This function don't allow user to enter dot character '.' inside quantity field
        appContainer.addEventListener('keypress', function(e) {
            if (e.target.classList.contains('el-input__inner') && !e.target.parentElement.classList.contains('promo__input')) {
                var regex = new RegExp('^[0-9]+$');
                var key = e.key;
                if (key.indexOf('.') > -1 || !regex.test(key)) {
                    e.preventDefault();
                    return false;
                }
            }
        });
    }
})();
